import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from 'redux-thunk';
import { resultReducer, testSelectedReducer, authReducer } from './reducers/testReducer'; // Update this path if necessary

const rootReducer = combineReducers({
  result: resultReducer,
  testSelected: testSelectedReducer,
  auth: authReducer,
  // Add other reducers here if you have them
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
